import React from 'react';
import { CurrentCollectionProvider } from '@europrocurement/l2d-modules';
import { useParams } from 'react-router';
import OrderDuplicate from './OrderDuplicate';

const OrderDuplicateWrapper: React.FunctionComponent = function () {
    const { idOrder } = useParams();
    if (!idOrder) {
        console.warn(`Commande non trouvée paramètres url:  ${idOrder}`);
        throw new Error(`Commande non trouvée paramètres url:  ${idOrder}`);
    }

    return (
        <CurrentCollectionProvider
            autoload
            idCollection={idOrder}
        >
            <OrderDuplicate />
        </CurrentCollectionProvider>
    );
};

export default OrderDuplicateWrapper;
